"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenshareButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const react_1 = require("react");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const video_frame_1 = require("../video_frame");
const screenshare_request_messages_1 = require("./screenshare_request_messages");
const ScreenshareButton = ({ onEnterScreenshareRequest, onCancel, onExitScreenshareRequest, isScreenShareRequest, cameraSubject, cameraRequestState, }) => {
    const [tooltipOpen, setTooltipOpen] = (0, react_1.useState)(false);
    const [tooltipMessage, setTooltipMessage] = (0, react_1.useState)();
    const [hover, setHover] = (0, react_1.useState)(false);
    const [hoverMessage, setHoverMessage] = (0, react_1.useState)();
    const pendingRequest = (cameraRequestState === video_frame_1.CameraRequestState.PENDING &&
        isScreenShareRequest &&
        cameraSubject !== streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_SCREEN) ||
        (cameraRequestState === video_frame_1.CameraRequestState.PENDING &&
            !isScreenShareRequest &&
            cameraSubject === streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_SCREEN);
    const shareScreenRequestDenied = cameraRequestState === video_frame_1.CameraRequestState.REQUEST_DENIED && isScreenShareRequest;
    const exitScreenShareRequestDenied = cameraRequestState === video_frame_1.CameraRequestState.REQUEST_DENIED &&
        cameraSubject === streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_SCREEN;
    const initialRequest = cameraRequestState === video_frame_1.CameraRequestState.INITIAL;
    (0, react_1.useEffect)(() => {
        // If a screenshare request was fulfilled, the button moves and if the expert's mouse stayed in the same spot
        // then the tooltip continued to show even when the button wasn't hovered over
        setHover(false);
    }, [cameraSubject]);
    (0, react_1.useEffect)(() => {
        // Show prompt if not currently in screenshare mode
        if (initialRequest && cameraSubject !== streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_SCREEN) {
            setHoverMessage((0, jsx_runtime_1.jsx)(screenshare_request_messages_1.ScreenshareRequestPrompt, {}));
            // Show exit screenshare message if currently in screenshare mode
        }
        else if (initialRequest && cameraSubject === streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_SCREEN) {
            setHoverMessage((0, jsx_runtime_1.jsx)(screenshare_request_messages_1.ExitScreenshare, {}));
        }
        else if (isScreenShareRequest && pendingRequest) {
            setHoverMessage((0, jsx_runtime_1.jsx)(screenshare_request_messages_1.ScreensharePending, {}));
        }
    }, [initialRequest, cameraSubject, isScreenShareRequest, pendingRequest]);
    (0, react_1.useEffect)(() => {
        if (shareScreenRequestDenied && cameraSubject !== streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_SCREEN) {
            setTooltipMessage((0, jsx_runtime_1.jsx)(screenshare_request_messages_1.ScreenshareRequestDenied, { onCancel: () => {
                    setTooltipOpen(false);
                    onCancel();
                }, onRequest: () => {
                    setTooltipOpen(false);
                    onEnterScreenshareRequest();
                } }));
            setTooltipOpen(true);
        }
        else if (exitScreenShareRequestDenied &&
            cameraSubject === streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_SCREEN) {
            setTooltipMessage((0, jsx_runtime_1.jsx)(screenshare_request_messages_1.ExitScreenshareRequestDenied, { onCancel: () => {
                    setTooltipOpen(false);
                    onCancel();
                }, onRequest: () => {
                    setTooltipOpen(false);
                    onExitScreenshareRequest();
                } }));
            setTooltipOpen(true);
        }
    }, [
        shareScreenRequestDenied,
        exitScreenShareRequestDenied,
        cameraSubject,
        onCancel,
        onEnterScreenshareRequest,
        onExitScreenshareRequest,
    ]);
    const closeTooltip = (0, react_1.useCallback)(() => {
        if (tooltipOpen) {
            setTooltipOpen(false);
            onCancel();
        }
    }, [tooltipOpen, onCancel]);
    const handleMouseEnter = (0, react_1.useCallback)(() => {
        setHover(true);
    }, []);
    const handleMouseLeave = (0, react_1.useCallback)(() => {
        setHover(false);
    }, []);
    return ((0, jsx_runtime_1.jsx)(ui_react_1.Sensor, Object.assign({ onClickOutside: closeTooltip, onEscape: closeTooltip }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Tooltip, Object.assign({ placement: "right", fallbackPlacements: ['left', 'top'], distance: 20, showTooltip: tooltipOpen || hover, message: tooltipOpen ? tooltipMessage : hoverMessage, borderRadius: "6px", offsetValue: cameraRequestState === video_frame_1.CameraRequestState.PENDING && isScreenShareRequest
                ? 0
                : 15 }, { children: pendingRequest ? ((0, jsx_runtime_1.jsx)(SpinnerContainer, Object.assign({ onMouseOver: handleMouseEnter, onMouseOut: handleMouseLeave }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Spinner, { size: "40px", color: "white" }) }))) : ((0, jsx_runtime_1.jsx)(ScreenshareIconButton, { label: 'Request Screen Share', iconName: cameraSubject === streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_SCREEN
                    ? 'ScreenshareCancelIcon'
                    : 'ScreenshareIcon', background: 'black', fill: 'white', onClick: cameraSubject === streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_SCREEN
                    ? onExitScreenshareRequest
                    : onEnterScreenshareRequest, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave })) })) })));
};
exports.ScreenshareButton = ScreenshareButton;
const ScreenshareIconButton = (0, ui_react_1.styled)(ui_react_1.IconButton) `
    opacity: 0.9;

    &:active {
        opacity: 0.64;
        transform: scale(0.92);
    }
`;
const SpinnerContainer = ui_react_1.styled.div `
    opacity: 0.9;
    margin-bottom: 8px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
`;
//# sourceMappingURL=screenshare_button.js.map